import { j as r } from "./jsx-runtime-944c88e2.js";
import * as x from "react";
import { y as d } from "./index-a0534bb4.js";
import { c as h, L as j, I as u, H as l } from "./form-2514c6d8.js";
import { w as f } from "./form-field-wrapper.hoc-d784197f.js";
import "./index-efd35e77.js";
import "./index-93802845.js";
import "./index-c07310bf.js";
import "./index-64063129.js";
import "react-dom";
import "./auto-scroll-b2de6e53.js";
import "./index.es-6889c727.js";
import "./Label-079ad7bc.js";
import "./package-metadata-3dcf116a.js";
import "./FloatingLabel-922c628f.js";
import "./Button-4c83e316.js";
import "./package-metadata-9ad1330d.js";
import "./theme-b013fa81.js";
import "./ButtonGroup-a9850ef0.js";
import "./Popup-b6c9078b.js";
import "./surface-71c0d1c6.js";
import "./Dialog-a72b336a.js";
import "./FormElement-65f04cfd.js";
const c = (t) => t.maxLength ? /* @__PURE__ */ r.jsx(g, { ...t }) : /* @__PURE__ */ r.jsx(d, { ...t }), G = f(c), J = ({
  validationMessage: t,
  touched: e,
  modified: m,
  visited: s,
  label: a,
  hint: i,
  fieldWrapperClassName: p,
  ...o
}) => {
  const n = e && t;
  return /* @__PURE__ */ r.jsxs(h, { className: p, children: [
    /* @__PURE__ */ r.jsxs(j, { editorId: o.id, editorValid: o.valid, children: [
      a,
      " ",
      o.required && /* @__PURE__ */ r.jsx("span", { className: "error-color", children: " *" })
    ] }),
    /* @__PURE__ */ r.jsx(c, { ...o }),
    n && /* @__PURE__ */ r.jsx(u, { children: t }),
    !n && /* @__PURE__ */ r.jsx(l, { children: i })
  ] });
}, g = ({ onChange: t, ...e }) => {
  const [m, s] = x.useState(""), a = (i) => {
    s(i.value);
  };
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsx(
      d,
      {
        maxLength: e.maxLength,
        value: m,
        onChange: (i) => {
          a(i), t && t(i);
        },
        ...e
      }
    ),
    /* @__PURE__ */ r.jsxs(l, { direction: "end", children: [
      m.length,
      " / ",
      e.maxLength
    ] })
  ] });
};
export {
  J as FormElementTextArea,
  c as TextArea,
  G as TextAreaFormField
};
